<div class="d-flex align-items-center gap-1">
  @if (setting?.crudOptions && setting?.crudOptions?.view) {
    <button
      type="button"
      class="grid__table__actions__buttons p-0"
      (click)="clickHandler(setting!.crudOptions!.view)">
      <span class="Appkit4-icon icon-view-outline"></span>
    </button>
  }
  @if (setting?.crudOptions && setting?.crudOptions?.edit) {
    <button
      type="button"
      class="grid__table__actions__buttons p-0"
      (click)="clickHandler(setting!.crudOptions!.edit)">
      <span class="Appkit4-icon icon-edit-outline"></span>
    </button>
  }
  @if (setting?.crudOptions && setting?.crudOptions?.delete) {
    <button
      type="button"
      class="grid__table__actions__buttons p-0"
      (click)="clickHandler(setting!.crudOptions!.delete)">
      <span class="Appkit4-icon icon-delete-outline"></span>
    </button>
  }
  @if (setting?.actionButtons) {
    @for (actionButton of setting!.actionButtons; track $index) {
      <button
        type="button"
        ap-tooltip
        direction="top"
        [tooltipContent]="actionButton.label"
        class="grid__table__actions__buttons p-0"
        (click)="actionButton.command(data)">
        <span class="Appkit4-icon" [ngClass]="actionButton.icon"></span>
      </button>
    }
  }
</div>
